module.exports = __webpack_public_path__ + "img/fitbit.63bbf067.png";